'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/millisecondsAfter.js
// module id = 178
// module chunks = 0